import React, { useEffect, useRef, useState } from "react";

export default function InstagramCarousel({
  images = [],
  interval = 3000,
}) {
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);

  // autoplay
  useEffect(() => {
    if (!images.length) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images, interval]);

  const next = () =>
    setIndex((prev) => (prev + 1) % images.length);

  const prev = () =>
    setIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );

  // touch swipe mobile
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;

    const delta =
      e.changedTouches[0].clientX - touchStartX.current;

    if (delta > 50) prev();
    if (delta < -50) next();

    touchStartX.current = null;
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "600px",
        margin: "auto",
        overflow: "hidden",
        borderRadius: "12px",
      }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {/* Track */}
      <div
        style={{
          display: "flex",
          transform: `translateX(-${index * 100}%)`,
          transition: "transform 0.5s ease",
        }}
      >
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`slide-${i}`}
            style={{
              width: "100%",
              flexShrink: 0,
              objectFit: "cover",
            }}
          />
        ))}
      </div>

      {/* Botões */}
      <button onClick={prev} style={navBtn("left")}>
        ‹
      </button>
      <button onClick={next} style={navBtn("right")}>
        ›
      </button>

      {/* Indicadores */}
      <div style={dotsWrapper}>
        {images.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            style={{
              ...dot,
              opacity: i === index ? 1 : 0.4,
            }}
          />
        ))}
      </div>
    </div>
  );
}

const navBtn = (side) => ({
  position: "absolute",
  top: "50%",
  [side]: "10px",
  transform: "translateY(-50%)",
  background: "rgba(0,0,0,0.4)",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  cursor: "pointer",
  borderRadius: "8px",
});

const dotsWrapper = {
  position: "absolute",
  bottom: "10px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: "6px",
};

const dot = {
  width: "8px",
  height: "8px",
  background: "#fff",
  borderRadius: "50%",
  cursor: "pointer",
};
